// GlobalToast.js
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Function to display a success toast
export const showSuccessToast = (message) => {
  toast.success(message, {
    hideProgressBar: true,
    autoClose: 2000,
    pauseOnHover: false,
    style: { color: '#FFF', backgroundColor: "#32ab13" },
    icon: <i className='bx bx-check-circle'></i>,
    closeButton : <i className='bx bx-x'></i>,
  });
};

// Function to display an error toast
export const showErrorToast = (message) => {
  toast.error(message, {
    hideProgressBar: true,
    autoClose: 2000,
    pauseOnHover: false,
    style: { color: '#FFF', backgroundColor: "#f02769" },
    icon: <i className='bx bx-x-circle'></i>,
    closeButton : <i className='bx bx-x'></i>,
  });
};

// Function to display a warning toast
export const showWarningToast = (message) => {
  toast.warn(message);
};

// Function to display an info toast
export const showInfoToast = (message) => {
  toast.info(message);
};

const GlobalToast = () => {
  return (
    <ToastContainer />
  );
};

export default GlobalToast;
